import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { expireCompanion } from '../redux/companionSlice';
import { companionExpiresAt } from '../services/companionService';
import { useLocation, useNavigate } from 'react-router-dom';
import { addEvenementSelect, addPlan } from '../redux/evenementsSlice';
import { URL } from '../redux/api';
import { capture } from '../services/analytics';

export default function CompanionSession() {
  const token = useSelector(state => state.companion.token);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const session = useSelector(state => state.companion);
  const selectedId = useSelector(state => state.evenements.evenementSelect?.id);
  useEffect(() => {
    if (session.expired && !['/login', '/', '/companion'].includes(pathname))
      navigate('/companion', { replace: true });
  }, [session.expired, navigate, pathname]);
  useEffect(() => {
    if (session.token && selectedId !== session.event.id) {
      dispatch(addEvenementSelect(session.event));
      dispatch(addPlan(session.event.plan ? `${URL}/plan-view/${session.event.id}/preview` : ''));
    }
  }, [session, selectedId, dispatch]);
  useEffect(() => {
    if (!token) return undefined;
    let timer;
    const check = () => {
      window.clearTimeout(timer);
      const remaining = companionExpiresAt(token) - Date.now();
      if (remaining <= 0) {
        capture('companion_session_expired');
        dispatch(expireCompanion());
      } else {
        timer = window.setTimeout(check, Math.min(remaining, 2147483647));
      }
    };
    check();
    window.addEventListener('focus', check);
    document.addEventListener('visibilitychange', check);
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener('focus', check);
      document.removeEventListener('visibilitychange', check);
    };
  }, [token, dispatch]);
  return null;
}
